import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";
import { TableCustom } from "../../components/Table";
import FormRender from "../../components/FormRender";
import { MdRefresh } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { CREDIT_HISTORY_TABLE_COLUMNS, CREDIT_ORG_FORM_SETTINGS } from "../../helper";
import { Paginator } from "../../components/Paginator";

const CreditHistory = () => {
  const axiosInstance = useAxiosInstance();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    org: {},
  });

  const [page, setPage] = useState(1);
  const [intermidiatePageNumber, setIntermidiatePageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [data, setData] = useState({});
  const [historyLoading, setHistoryLoading] = useState(false);

  const selectedOrgId = Object.keys(formData.org)[0];

  const fetchCreditHistory = (orgId) => {
    if (!orgId) return;

    setHistoryLoading(true);
    axiosInstance
      .get(`wkl/credits/get_credit_logs/`, {
        params: {
          org_id: orgId,
          page: page,
          page_size: Number(pageSize),
        },
      })
      .then((res) => {
        setData(res.data);
        setIntermidiatePageNumber(res.data?.current_page || 1);
      })
      .catch((err) => {
        console.error("Error fetching credit history:", err);
        toast.error("Failed to fetch credit history");
        setData({});
      })
      .finally(() => setHistoryLoading(false));
  };

  useEffect(() => {
    if (selectedOrgId) {
      fetchCreditHistory(selectedOrgId);
    } else {
      setData({});
    }
  }, [selectedOrgId, page, pageSize]);

  useEffect(() => {
    setPage(1);
    setIntermidiatePageNumber(1);
  }, [selectedOrgId]);

  return (
    <div className="p-5">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <button
            onClick={() => navigate("/credit-management")}
            className="flex items-center gap-2 text-black hover:text-gray-600 mb-4"
          >
            <FaArrowLeft /> Back to Credit Management
          </button>
          <h1 className="text-2xl font-semibold text-black">Credit History</h1>
        </div>

        <div className="bg-white border rounded-lg p-4 mb-6">
          <h2 className="text-lg font-semibold mb-4">Select Organisation</h2>
          <FormRender
            formData={formData}
            setFormData={setFormData}
            formSettings={CREDIT_ORG_FORM_SETTINGS}
          />
        </div>

        <div className="bg-white border rounded-lg p-4">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Credit History</h2>
            {selectedOrgId && (
              <button
                onClick={() => fetchCreditHistory(selectedOrgId)}
                disabled={historyLoading}
                className="p-2 hover:bg-gray-100 rounded-lg disabled:opacity-50"
                title="Refresh"
              >
                <MdRefresh className={historyLoading ? "animate-spin" : ""} />
              </button>
            )}
          </div>
          {!selectedOrgId ? (
            <div className="text-center py-8 text-gray-500">
              Select an organisation to view credit history
            </div>
          ) : historyLoading ? (
            <div className="text-center py-8">Loading...</div>
          ) : data?.data?.length > 0 ? (
            <>
              <TableCustom
                columns={CREDIT_HISTORY_TABLE_COLUMNS}
                data={data}
              />
              <Paginator
                data={data}
                loading={historyLoading}
                setPage={setPage}
                setIntermidiatePageNumber={setIntermidiatePageNumber}
                intermidiatePageNumber={intermidiatePageNumber}
                setPageSize={setPageSize}
                pageSize={pageSize}
              />
            </>
          ) : (
            <div className="text-center py-8 text-gray-500">
              No credit history found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditHistory;